import { useEffect, useRef, EffectCallback } from 'react';

const useOnMount = (fn: EffectCallback) => {
  const onMountRef = useRef(fn);
  useEffect(() => onMountRef.current?.(), []);
};

export default useOnMount;
